import React,{Fragment} from "react"
import { withStyles } from '@material-ui/core/styles'
import { withTheme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import ReactSwipeEvents from 'react-swipe-events'
import { I18n } from 'react-redux-i18n'
import TodayIcon from '@material-ui/icons/Today'
import IconButton from '@material-ui/core/IconButton'

const styles = theme => ({
  slider: {
    width: '100%'
  },
  calendar: {
    padding: '1rem',
    backgroundColor: theme.palette.primary.main,
    fontWeight: 'bold'
  },
  table: {
    borderSpacing: '0',
    width: '100%',
    margin: '0 auto'
  },
  tableHead:{
    backgroundColor: theme.palette.grey["800"],
    color: theme.palette.primary.contrastText
  },
  tableCellHead: {
    padding: '0.3rem'
  },
  tableCellHeadWeekend: {
    backgroundColor: theme.palette.grey["700"],
  },
  tableCell: {
    padding: '0.8rem',
    verticalAlign: 'middle',
    textAlign: 'center',
    cursor: 'pointer',
    position: 'relative'
  },
  tableCellInMonth: {
    color: theme.palette.primary.contrastText
  },
  tableCellSelectedDate: {
    backgroundColor: theme.palette.primary.dark,
    borderRadius: '0.5rem',
    color: theme.palette.primary.contrastText

  },
  tableCellRight: {
    borderTopRightRadius: '0.3rem',
    borderBottomRightRadius: '0.3rem'
  },
  tableCellLeft: {
    borderTopLeftRadius: '0.3rem',
    borderBottomLeftRadius: '0.3rem'
  },
  today: {
    padding: '0.5rem 1.5rem',
    backgroundColor: theme.palette.grey["800"],
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold'
  },
  todayDate: {
    marginLeft: '1rem',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '22px'
  },
  todayButton: {
    color: theme.palette.primary.contrastText,
    float: 'right',
    height: '22px',
    width: '22px'
  }
});

class Calendar extends React.Component {
  render(){
    const { classes } = this.props

    return(
      <ReactSwipeEvents className={classes.slider} onSwipedRight={this.props.previousMonth} onSwipedLeft={this.props.nextMonth}>
        <Fragment>
          <Grid item container xs={12}
            className={classes.calendar}>
            <table className={classes.table}>
              <thead className={classes.tableHead}>
                <tr>
                  <th className={`${classes.tableCellHead} ${classes.tableCellLeft}`}>{I18n.t('month.mo')}</th>
                  <th className={classes.tableCellHead}>{I18n.t('month.tu')}</th>
                  <th className={classes.tableCellHead}>{I18n.t('month.we')}</th>
                  <th className={classes.tableCellHead}>{I18n.t('month.th')}</th>
                  <th className={classes.tableCellHead}>{I18n.t('month.fr')}</th>
                  <th className={`${classes.tableCellHead} ${classes.tableCellHeadWeekend}`}>{I18n.t('month.sa')}</th>
                  <th className={`${classes.tableCellHead} ${classes.tableCellRight} ${classes.tableCellHeadWeekend}`}>{I18n.t('month.su')}</th>
                </tr>
              </thead>
              <tbody>
                {this.props.calendar.weeks.map((week, index) =>
                  <Week
                    key={index}
                    classes={classes}
                    week={week}
                    currentDay={this.props.calendar.date}
                    appointments={this.props.calendar.appointments}
                    onClickDay={this.props.onClickDay}/>
                )}
              </tbody>
            </table>
          </Grid>
          <Grid container>
            <Grid item xs={9} className={classes.today}>
              {this.props.calendar.date.isSame(new Date(), "day") ?
                (
                  <span>
                    {I18n.t('month.today')}
                    <span className={classes.todayDate}>
                      {this.props.calendar.date.format('DD-MM-YYYY')}
                    </span>
                  </span>
                ) : (
                  <span>
                    {this.props.calendar.date.format('dddd')}
                    <span className={classes.todayDate}>
                      {this.props.calendar.date.format('DD-MM-YYYY')}
                    </span>
                  </span>
                )
              }
            </Grid>
            <Grid item xs={3} className={classes.today}>
              <IconButton className={classes.todayButton} onClick={this.props.onClickSetToday} aria-label="Today">
                <TodayIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Fragment>
      </ReactSwipeEvents>
    )
  }
}

function Week(props){
  return(
    <tr className={props.classes.tableRow}>
      {props.week.days.map((day, index) =>
        <Day
          key={index}
          day={day}
          currentDay={props.currentDay}
          classes={props.classes}
          appointments={props.appointments}
          onClickDay={props.onClickDay} />
      )}
    </tr>
  )
}

function Day(props){
  const firstAppointment = props.appointments.find(a => {
    if(moment().diff(moment(a.tot_datum+a.tot_tijd, 'YYYYMMDDhhmm')) <= 0){
      if(a.van_datum === a.tot_datum){
        return (props.day.diff(moment(a.van_datum, 'YYYYMMDD')) === 0)
      }
      return props.day.isBetween(moment(a.van_datum, 'YYYYMMDD').startOf('day'), moment(a.tot_datum, 'YYYYMMDD').endOf('day'))
    }
    return null
  })

  if(props.currentDay.isSame(props.day, 'day')){
    return(
      <td className={`${props.classes.tableCell} ${props.classes.tableCellSelectedDate}`} onClick={() => props.onClickDay(props.day)}>
        {props.day.date()}
        {typeof firstAppointment !== 'undefined' ? (<span className="appointment-circle" style={{color: firstAppointment.kleuren.kleurcode}}></span>) : (<Fragment />)}
      </td>
    )
  }else if(props.day.isSame(props.currentDay, 'month')){
    return(
      <td className={`${props.classes.tableCell} ${props.classes.tableCellInMonth}`} onClick={() => props.onClickDay(props.day)}>
        {props.day.date()}
        {typeof firstAppointment !== 'undefined' ? (<span className="appointment-circle" style={{color: firstAppointment.kleuren.kleurcode}}></span>) : (<Fragment />)}
      </td>
    )
  }else{
    return(
      <td className={props.classes.tableCell} onClick={() => props.onClickDay(props.day)}>
        {props.day.date()}
        {typeof firstAppointment !== 'undefined' ? (<span className="appointment-circle" style={{color: firstAppointment.kleuren.kleurcode}}></span>) : (<Fragment />)}
      </td>
    )
  }
}

export default withTheme()(withStyles(styles)(Calendar))



// WEBPACK FOOTER //
// ./src/js/components/pages/month/calendar/Calendar.js